<template>
  <div>
    <slot
      :selectedOption="selectedOption"
      :orientation="orientation"
      :id="id"
    ></slot>
  </div>
</template>
<script>
export default {
  name: "bc-radio-option-slot",
  props: {
    selectedOption: {
      type: String,
      default: null,
    },
    orientation: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
  render() {
    return this.$slots.default;
  },
};
</script>